import { render, staticRenderFns } from "./NavigationSectionSubpageStepback.vue?vue&type=template&id=177b7135&scoped=true&"
import script from "./NavigationSectionSubpageStepback.vue?vue&type=script&lang=ts&"
export * from "./NavigationSectionSubpageStepback.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationSectionSubpageStepback.vue?vue&type=style&index=0&id=177b7135&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177b7135",
  null
  
)

export default component.exports